import Vue from 'vue';
import Modal from '@/components/Modal.vue';

const instance: any = {
  create: function create(config: any) {
    const ModalComp = Vue.extend(Modal);
    instance.modal = new ModalComp(
      {
        el: document.createElement('div'),
        propsData: {
          config,
          onHide: instance.hide
        }
      }
    );
    document.body.appendChild(instance.modal.$el);
  },
  show: function show(config: IModal) {
    instance.create(config);
    instance.modal.show = true;
  },
  hide: function hide() {
    instance.modal && (instance.modal.show = false);
    if (document.body.contains(instance.modal.$el)) {
      document.body.removeChild(instance.modal.$el);
    }
    instance.modal.$destroy();
  }
};

export default instance;
